import React from "react";

import { Grid, Section, Select } from "@samskip/frontend-components";
import {
  Control,
  DeepRequired,
  FieldErrorsImpl,
  useWatch,
} from "react-hook-form";
import { useTranslation } from "react-i18next";

import { BookingTemplateFormTypes } from "@assets/formTypes";
import { RegistryTypes, PortTypes, CommonTypes } from "@assets/types";
import { getErrorMessage } from "@assets/utilities";
import {
  incotermLabelMapper,
  incotermValueMapper,
  portLabelMapper,
  portValueMapper,
} from "@assets/utilities/labelMapperUtils";
import { WithFormController } from "@components";

type IncotermsSectionProps = {
  control: Control<BookingTemplateFormTypes.RouteForm>;
  errors: FieldErrorsImpl<DeepRequired<BookingTemplateFormTypes.RouteForm>>;
  updateIncotermPlaces: CommonTypes.CallbackFunction;
  incotermPoints: PortTypes.Port[];
  incoterms: RegistryTypes.Incoterm[];
};

const IncotermsSection = ({
  control,
  errors,
  incotermPoints,
  updateIncotermPlaces,
  incoterms,
}: IncotermsSectionProps) => {
  const { t } = useTranslation();

  const incotermValue = useWatch({ control, name: "Incoterm" });

  return (
    <Section title={t("LABEL_INCOTERMS")}>
      <Grid mdCol={3}>
        <WithFormController control={control} name="Incoterm">
          <Select
            errorMessage={getErrorMessage("Incoterm", errors)}
            fullWidth
            getOptionLabel={incotermLabelMapper}
            getOptionValue={incotermValueMapper}
            hasError={errors.Incoterm != null}
            id="incoterm"
            isClearable
            label={t("LABEL_TERMS")}
            onChange={updateIncotermPlaces}
            options={incoterms}
            placeholder={t("PLACEHOLDER_SELECT_INCOTERMS")}
            portaling
          />
        </WithFormController>
        <WithFormController control={control} name="IncotermPoint">
          <Select
            disabled={!incotermValue || incotermPoints.length <= 1}
            disabledTooltipContent={
              !incotermValue ? t("ERROR_SELECT_INCOTERMS_FIRST") : ""
            }
            fullWidth
            getOptionLabel={portLabelMapper}
            getOptionValue={portValueMapper}
            id="incoterm-point"
            label={t("LABEL_PLACE")}
            options={incotermPoints}
            placeholder={t("PLACEHOLDER_SELECT_INCOTERMS_PLACE")}
          />
        </WithFormController>
      </Grid>
    </Section>
  );
};

export default IncotermsSection;
